export const ONE_KB = 1_024;
export const ONE_MB = 1_024 * ONE_KB;
export const ONE_GB = 1_024 * ONE_MB;
export const ONE_TB = 1_024 * ONE_GB;